/**
 * set of functions to enforce a data structure
 */
import fieldsToStructure from './fieldsToStructure';

const preservedFields = [
  'name',
  'typeId',
];

export default {
  ...fieldsToStructure(preservedFields),
  id(option) {
    return option.optionId;
  },
};



// WEBPACK FOOTER //
// ./~/virgo/src/structures/onboardingOptionStructure.js